import React from 'react'
import { message as AntMessage } from 'antd'
import { WarningWhiteIcon } from './../assets/icons'
import { AlertWhiteIcon } from './../assets/icons'
import { SuccessWhiteIcon } from './../assets/icons'
import './MessageV2.less'

AntMessage.config({
  top: 50,
  duration: 1.5,
})

const contentStyle = {
  display: 'flex',
  alignItems: 'center',
}
/**
 * Keep below code to implementation of close button
 */
/*const closeBtnStyle = {
  position: 'absolute',
  right: 0,
  background: 'transparent',
  border: 'none',
}*/
//This is temp fix for when banner is full
let isFull = null
const iconType = {
  error: <AlertWhiteIcon/>,
  success: <SuccessWhiteIcon/>,
  warning: <WarningWhiteIcon/>,
}
const getNode = (alertFunc, type, content, duration, onClose) => {
  content =
    <div style={contentStyle}> {iconType[type] || <SuccessWhiteIcon/>} <span style={{ marginLeft: 8 }}>{content}</span>
    </div>
  alertFunc(content, duration, onClose)
}

const func = () => {
  const obj = {}
  Object.entries(AntMessage).map((eachMap) => {
    const [key, value] = eachMap
    if (key !== 'config' && key !== 'destroy' && key !== 'loading' && key !== 'warn') {
      obj[key] = getNode.bind(this, value, key)
    } else {
      obj[key] = value
    }

  })
  return obj
}


const Message = {
  ...AntMessage, v2: (options) => {
    isFull = true
    AntMessage.config({ ...options, prefixCls: 'pan-v2-message' })
  },
  ...func(),

}


export default Message
